import styled, { createGlobalStyle } from 'styled-components';

export const Container = styled.div`
  && {
    .sensei-ui-menu.sensei-ui-menu-dark,
    .sensei-ui-menu.sensei-ui-menu-sub.sensei-ui-menu-inline {
      background-color: transparent;
    }

    .sensei-ui-menu-dark.sensei-ui-menu-submenu > .sensei-ui-menu {
      background-color: ${({ theme }) => theme.colors.neutral.palette800};
    }

    .sensei-ui-menu-sub li.sensei-ui-menu-item {
      margin-bottom: ${({ theme }) => theme.spacing.xs}px;
    }

    li.sensei-ui-menu-item {
      margin-bottom: ${({ theme }) => theme.spacing.sm}px;

      svg {
        top: 3px;
      }

      &.sensei-ui-menu-item-selected {
        position: relative;
        overflow: initial;
        background-color: ${({ theme }) => theme.colors.primary.palette400}20;

        svg {
          top: 3px;
          fill: ${({ theme }) => theme.colors.primary.palette500};
        }

        &:before {
          content: '';
          width: 1px;
          height: 100%;
          position: absolute;
          background-color: ${({ theme }) => theme.colors.primary.palette500};
          right: -18px;
        }
      }
    }
  }

  aside > div {
    background-color: ${({ theme }) => theme.colors.neutral.palette800};
    box-shadow: none;
    transition: width ease-in-out ${({ theme }) => theme.transitions.duration.faster}ms;
    border-right: 1px solid ${({ theme }) => theme.colors.neutral.palette600};
  }

  main {
    max-height: 100vh;
    overflow-y: auto;
    padding-top: ${({ theme }) => theme.spacing.md}px;
    padding-bottom: ${({ theme }) => theme.spacing.lg}px;
    background-color: ${({ theme }) => {
      return theme.colors.neutral.background;
    }};
  }

  > div {
    height: initial;
    min-height: 100vh;
  }

  .container-top,
  .container-bottom {
    padding: ${({ theme }) => theme.spacing.sm}px;
  }
`;

export const GlobalStyles: any = createGlobalStyle`
  body {
    background-color: ${({ theme }) => theme.colors.neutral.background};
  }

  ::selection {
    outline: 2px solid ${({ theme }) => theme.colors.secondary.palette500};
    background: ${({ theme }) => theme.colors.secondary.palette500};
    color: ${({ theme }) => theme.colors.neutral.palette900};
  }
`;
